module.exports = __webpack_public_path__ + "img/machinetop.35e52ef0.png";